import PropTypes from 'prop-types';
import InputPhoneLine from '../../../../juristec-ui/core/InputPhoneLine';

const PhoneInput = ({
  label, state, handle,
}) => (
  <>
    <h5 className={state.error ? 'field-error-label' : ''}>
      {label}
    </h5>
    <InputPhoneLine
      label=""
      type="tel"
      value={state.value}
      // errorMessage={state.errorMsg}
      // error={state.errorMsg.length > 0}
      onChange={handle}
    />
    {state.errorMsg.length > 0 && (
      <span className="field-error-msg">
        {state.errorMsg}
      </span>
    )}
  </>
);

PhoneInput.propTypes = {
  label: PropTypes.string.isRequired,
  state: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
  }).isRequired,
  handle: PropTypes.func.isRequired,
};

export default PhoneInput;
